import { useStore } from "@stores";
import { useEffect } from "react";

export const useLatestPromotions = (count = 6) => {
  const { promotionStore } = useStore();

  useEffect(() => {
    promotionStore.getLatest(count);
  }, [promotionStore, count]);

  return {
    latest: promotionStore.latest,
    loading: promotionStore.latestLoading,
  };
};
